import React from "react";
import {AppointmentCounterText} from "../components/my-page/AppointmentCounterText";
import {Box, List} from "@mui/material";
import {AppointmentListItem} from "../components/my-page/AppointmentListItem";
import {UserAppointment} from "../models/UserAppointment";

interface JoinedAppointmentsPageProps {
    appointments: UserAppointment[]
}

export const JoinedAppointmentsPage: React.FC<JoinedAppointmentsPageProps> = ({appointments}) => {
    return (
        <>
            <AppointmentCounterText appointmentCount={appointments.length}/>
            {appointments.length === 0 ? <EmptyJoinedAppointmentBody/> : <JoinedAppointmentBody appointments={appointments}/>}
        </>
    )
}

const EmptyJoinedAppointmentBody: React.FC = () => {
    return (
        <Box alignItems={'center'} height={'100%'}>
            <Box sx={{textAlign: 'center', color: '#9E9E9E'}}>
                <span style={{fontSize: '18px', fontWeight: 500}}>아직 참여한 약속이 없어요</span>
                <Box height={"12px"}/>
                <span style={{fontSize: '15px', fontWeight: 500}}>공유받은 약속 링크를 통해<br/>약속 날짜를 선택할 수 있어요</span>
            </Box>
        </Box>
    )
}

interface JoinedAppointmentBodyProps {
    appointments: UserAppointment[],
}

const JoinedAppointmentBody: React.FC<JoinedAppointmentBodyProps> = ({ appointments }) => {
    return (
        <List>
            {appointments.map(appointment => <AppointmentListItem appointment={appointment} key={appointment.id} />)}
        </List>
    )
}